import {
  FiUserCheck,
  FiLock,
  FiFileText,
  FiArchive,
  FiMessageSquare,
  FiCreditCard,
} from 'react-icons/fi';

const valueProps = [
  {
    Icon: FiUserCheck,
    title: 'Identity Verification',
    desc: 'Know exactly who signed — Aadhaar-linked identity verified on every document.',
  },
  {
    Icon: FiLock,
    title: 'Secure Workflows',
    desc: 'End-to-end encrypted signing flows with tamper-evident document records.',
  },
  {
    Icon: FiFileText,
    title: 'Complete Audit Trails',
    desc: 'Every action timestamped. Every event logged. Full chain of custody, always.',
  },
  {
    Icon: FiArchive,
    title: 'Evidence Records',
    desc: 'Signing events stored as legal evidence, not just documents.',
  },
  {
    Icon: FiMessageSquare,
    title: 'WhatsApp-First Delivery',
    desc: 'Send, receive, and sign documents via WhatsApp — where India already works.',
  },
  {
    Icon: FiCreditCard,
    title: 'Aadhaar eSign & DSC',
    desc: 'Native support for Aadhaar-based eSign and Digital Signature Certificates.',
  },
];

export default valueProps;
